import algoliaInsights from '@module/Algolia/resources/js/search/AlgoliaInsights';
import { urlQueryIdParamName } from '@module/Algolia/resources/js/search/helpers';

document.addEventListener('click', (event) => {
  if (event.target?.dataset?.algoliaInsights) {
    const data = JSON.parse(event.target.dataset.algoliaInsights);
    algoliaInsights.handleClick(
      { ...data, queryID: data.queryID ?? new URLSearchParams(window.location.search).get(urlQueryIdParamName) },
      data.type,
    );
  }
});
